import { routes as routesAccessTokens } from "@Organizations/AccessTokens/routes";
import { routes as routesOrganizationUnits } from "@Organizations/OrganizationUnits/routes";
import { routes as routesSessions } from "@Organizations/Sessions/routes";
import { routes as routesUsers } from "@Organizations/Users/routes";
import { routes as routesWorkspaces } from "@Organizations/Workspaces/routes";

export const routes = [
    ...routesAccessTokens,
    ...routesOrganizationUnits,
    ...routesSessions,
    ...routesUsers,
    ...routesWorkspaces,
]
